<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col md="12">
				<b-card class="cProdaja">
					<div slot="header">
						<b-row>
							<b-col align-self="start">
								Potrditve plačill
							</b-col>
							<b-col align-self="end" class="filterRacunovodjaPotrdil">
								<datum-filter-dropdown ref="racunovodja_potrdilDropdown" v-model="potrditvePlacilTable_props.inputFilter.datum_racunovodja_potrdil" @input="onPotrditvePlacilTableFilterChange" v-bind:default_label="'Aktivni'" v-bind:noFutureValues="true"/>
							</b-col>
						</b-row>
					</div>
					<b-table 
						ref="potrditvePlacilTable"
						show-empty
						responsive="sm"
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						head-variant="light"
						class="tProdaja"
						:items="potrditvePlacilTable_dataProvider"
						:fields="potrditvePlacilTable_props.fields"
						:current-page="potrditvePlacilTable_props.currentPage"
						:per-page="potrditvePlacilTable_props.perPage"
						@row-clicked="potrditvePlacilTable_rowClick">
						<template slot="skupni_znesek" slot-scope="data">
							<div v-if="data.item.skupni_znesek && data.item.skupni_znesek > 0">{{ data.item.skupni_znesek | hr_money }}</div>
							<div v-else>/</div>
						</template>
						<template slot="prodajalec_potrditev" slot-scope="data">
							<b-badge v-if="data.item.datum_prodajalec_potrdil" variant="success">Potrjeno dne {{ data.item.datum_prodajalec_potrdil | hr_date }}</b-badge>
							<b-badge v-else variant="warning">Čaka na potrditev</b-badge>
						</template>
						<template slot="sekretar_potrditev" slot-scope="data">
							<b-badge v-if="data.item.datum_sekretar_potrdil" variant="success">Potrjeno dne {{ data.item.datum_sekretar_potrdil | hr_date }}</b-badge>
							<b-badge v-else variant="warning">Čaka na potrditev</b-badge>
						</template>
						<template slot="moderator_potrditev" slot-scope="data">
							<b-badge v-if="data.item.datum_moderator_potrdil" variant="success">Potrjeno dne {{ data.item.datum_moderator_potrdil | hr_date }}</b-badge>
							<b-badge v-else variant="warning">Čaka na potrditev</b-badge>
						</template>
						<template slot="racunovodja_potrditev" slot-scope="data">
							<b-badge v-if="data.item.datum_racunovodja_potrdil" variant="success">Potrjeno dne {{ data.item.datum_racunovodja_potrdil | hr_date }}</b-badge>
							<b-badge v-else variant="warning">Čaka na potrditev</b-badge>
						</template>
						<template slot="top-row">
							<td><b-form-input v-model="potrditvePlacilTable_props.inputFilter.ogrodje" type="text" @input="onPotrditvePlacilTableTextFilterChange" /></td>
							<td><b-form-input v-model="potrditvePlacilTable_props.inputFilter.libelle_modele" type="text" @input="onPotrditvePlacilTableTextFilterChange" /></td>
							<td><b-form-input v-model="potrditvePlacilTable_props.inputFilter.libelle_version" type="text" @input="onPotrditvePlacilTableTextFilterChange" /></td>
							<td><b-form-input v-model="potrditvePlacilTable_props.inputFilter.p_prodajalec_name" type="text" @input="onPotrditvePlacilTableTextFilterChange" /></td>
							<td><b-form-input v-model="potrditvePlacilTable_props.inputFilter.st_racuna" type="text" @input="onPotrditvePlacilTableTextFilterChange" /></td>
							<td></td>
							<td></td>
						</template>
					</b-table>
					<nav>
						<b-row>
							<b-col sm="10">
								<b-pagination class="navigacija" :total-rows="potrditvePlacilTable_props.totalRows" :per-page="potrditvePlacilTable_props.perPage" v-model="potrditvePlacilTable_props.currentPage" prev-text="Prejšnja" next-text="Naslednja" :limit="potrditvePlacilTable_props.naviLimit"/>
							</b-col>
							<b-col sm="2">
								<a class="page-link rows_total">Št. vrstic: {{potrditvePlacilTable_props.totalRows}}</a>
							</b-col>
						</b-row>
					</nav>
				</b-card>
				<mapa-modal ref="mapaModal" @userpotrdil-success="on_userPotrdilSuccess" />
			</b-col>
		</b-row>
		<b-row>
			<b-col md="12">
				<b-card header="Izstavitve računov" class="cProdaja">
					<b-table 
						ref="zeljeneIzstavitveRacunovTable"
						show-empty
						responsive="sm"
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						head-variant="light"
						class="tProdaja"
						:items="zeljeneIzstavitveRacunovTable_dataProvider"
						:fields="zeljeneIzstavitveRacunovTable.fields"
						:current-page="zeljeneIzstavitveRacunovTable.currentPage"
						:per-page="zeljeneIzstavitveRacunovTable.perPage"
						:filter="zeljeneIzstavitveRacunovTable.filter"
						@row-clicked="zeljeneIzstavitveRacunovTable_rowClick">
						<template slot="m_zeljena_izstavitev_racuna" slot-scope="data">
							{{ data.item.m_zeljena_izstavitev_racuna | hr_datetime }}
						</template>
						<template slot="m_datum_izstavitve_racuna" slot-scope="data">
							<b-badge v-if="data.item.m_datum_izstavitve_racuna" variant="success">Račun izstavljen dne {{ data.item.m_datum_izstavitve_racuna | hr_date }}</b-badge>
							<b-badge v-else variant="warning">Čaka na izstavitev</b-badge>
						</template>
						<template slot="pk_title" slot-scope="data">
							 <span v-if="data.item.pk_is_company == 1">{{ data.item.pk_company_title }} <span v-if="data.item.pk_contact_name != ''">({{ data.item.pk_contact_name }})</span></span>
							 <span v-else>{{ data.item.pk_first_name }} {{ data.item.pk_last_name }}</span>
						</template>
						<template slot="pu_title" slot-scope="data">
							{{ data.item.pu_last_name }} {{ data.item.pu_first_name }}
						</template>
					</b-table>
					<nav>
						<b-row>
							<b-col sm="10">
								<b-pagination class="navigacija" :total-rows="zeljeneIzstavitveRacunovTable.totalRows" :per-page="zeljeneIzstavitveRacunovTable.perPage" v-model="zeljeneIzstavitveRacunovTable.currentPage" prev-text="Prejšnja" next-text="Naslednja" :limit="zeljeneIzstavitveRacunovTable.naviLimit"/>
							</b-col>
							<b-col sm="2">
								<a class="page-link rows_total">Št. vrstic: {{zeljeneIzstavitveRacunovTable.totalRows}}</a>
							</b-col>
						</b-row>
					</nav>
				</b-card>
				<izstavitev-racuna-modal ref="izstavitevRacunaModal" @izstavitevRacuna_success="izstavitevRacuna_success"/>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<b-card header="Testna vozila" class="cProdaja">
					<b-table 
						ref="customKontoTable"
						show-empty
						responsive="sm"
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						head-variant="light"
						class="tProdaja"
						:items="customKontoTable_dataProvider"
						:fields="customKontoTable.fields"
						:current-page="customKontoTable.currentPage"
						:per-page="customKontoTable.perPage"
						:filter="customKontoTable.filter"
						@row-clicked="customKontoTable_rowClick">
						<template slot="libelle_options" slot-scope="data">
							<b-badge v-if="data.item.libelle_options != '' && data.item.libelle_options != 'null' && data.item.libelle_options != null" variant="" :title="getTitle(data.item.libelle_options)" v-b-tooltip.hover><i class="i_options fa fa-gears fa-lg" style="padding:2px;"></i></b-badge>
							<b-badge v-if="data.item.libelle_teinte != '' && data.item.libelle_teinte != 'null' && data.item.libelle_teinte != null" variant="" :title="getTitle(data.item.libelle_teinte)" v-b-tooltip.hover>
								<span v-if="data.item.barva != '' && data.item.barva != 'null' && data.item.barva != null" style="line-height:20px;">{{ data.item.barva }}</span>
								<span v-else style="line-height:20px;"><i class="fa fa-tint" style="margin-left:5px; margin-right:5px"></i></span>
							</b-badge>
						</template>
						<template slot="status" slot-scope="data">
							<b-badge v-if="isSold(data.item)" variant="success" :title="getSoldInfo(data.item)" v-b-tooltip.hover>Prodano</b-badge>
						</template>
						<template slot="datum_prve_registracije" slot-scope="data">
							{{ data.item.datum_prve_registracije | hr_date }}
						</template>
						<template slot="datum_kdaj_ga_moramo_prodati" slot-scope="data">
							{{ data.item.datum_kdaj_ga_moramo_prodati | hr_date }}
						</template>
						<template slot="datum_kdaj_ga_lahko_prodamo" slot-scope="data">
							{{ data.item.datum_kdaj_ga_lahko_prodamo | hr_date }}
						</template>
						<template slot="prodajna_cena" slot-scope="data">
							<div v-if="data.item.prodajna_cena && data.item.prodajna_cena > 0">{{ data.item.prodajna_cena | hr_money }}</div>
							<div v-else>/</div>
						</template>
						<template slot="st_kilometrov" slot-scope="data">
							<div v-if="data.item.st_kilometrov">{{ data.item.st_kilometrov }} km</div>
							<div v-else>/</div>
						</template>
						<template slot="top-row">
							<td></td>
							<td><b-form-input v-model="customKontoTable.inputFilter.ogrodje" type="text" @input="onCustomKontoTableFilterChange" /></td>
							<td><b-form-input v-model="customKontoTable.inputFilter.model" type="text" @input="onCustomKontoTableFilterChange" /></td>
							<td><b-form-input v-model="customKontoTable.inputFilter.verzija" type="text" @input="onCustomKontoTableFilterChange" /></td>
							<td><b-form-input v-model="customKontoTable.inputFilter.barva" type="text" @input="onCustomKontoTableFilterChange" /></td>
							<td><datum-filter-dropdown ref="datum_prve_registracijeDropdown" v-model="customKontoTable.inputFilter.datum_prve_registracije" @input="onCustomKontoTableFilterChange" /></td>
							<td><datum-filter-dropdown ref="datum_kdaj_ga_moramo_prodatiDropdown" v-model="customKontoTable.inputFilter.datum_kdaj_ga_moramo_prodati" @input="onCustomKontoTableFilterChange" /></td>
							<td><datum-filter-dropdown ref="datum_kdaj_ga_lahko_prodamoDropdown" v-model="customKontoTable.inputFilter.datum_kdaj_ga_lahko_prodamo" @input="onCustomKontoTableFilterChange" /></td>
							<td></td>
							<td></td>
						</template>
					</b-table>
					<nav>
						<b-row>
							<b-col sm="10">
								<b-pagination class="navigacija" :total-rows="customKontoTable.totalRows" :per-page="customKontoTable.perPage" v-model="customKontoTable.currentPage" prev-text="Prejšnja" next-text="Naslednja" :limit="customKontoTable.naviLimit"/>
							</b-col>
							<b-col sm="2">
								<a class="page-link rows_total">Št. vrstic: {{customKontoTable.totalRows}}</a>
							</b-col>
						</b-row>
					</nav>
				</b-card>
				<podrobnosti-vozila-modal ref="podrobnostiVozilaModal" @importdata_edit="importdata_edit"/>
				<vue-toastr ref="toastr"></vue-toastr>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import MapaModal from '@/components/MapaModal';
import PodrobnostiVozilaModal from '@/components/PodrobnostiVozilaModal';
import DatumFilterDropdown from '@/components/DatumFilterDropdown';
import IzstavitevRacunaModal from '@/components/Modals/IzstavitevRacunaModal';
import service from '@/service';
import settings from '@/settings.js';
import { format, parse } from 'date-fns';

export default {
	name: 'aktivnosti',
	components: {
		'mapa-modal': MapaModal,
		'podrobnosti-vozila-modal': PodrobnostiVozilaModal,
		'datum-filter-dropdown': DatumFilterDropdown,
		'izstavitev-racuna-modal': IzstavitevRacunaModal
	},
	filters: {
	},
	data: function () {
		return {
			potrditvePlacilTable_props: {
				items: [],
				fields: [
					{ key: 'ogrodje', label: 'VIN', sortable: true },
					{ key: 'libelle_modele', label: 'Model', sortable: true },
					{ key: 'libelle_version', label: 'Verzija', sortable: true },
					{ key: 'p_prodajalec_name', label: 'Prodajalec' },
					{ key: 'st_racuna', label: 'Št. računa RNS', sortable: true },
					{ key: 'skupni_znesek', label: 'Skupni znesek', sortable: true },
					{ key: 'prodajalec_potrditev', label: 'Potrditev prodajalca', sortable: true },
					{ key: 'sekretar_potrditev', label: 'Potrditev sekretarja', sortable: true },
					{ key: 'moderator_potrditev', label: 'Potrditev moderatorja', sortable: true },
					{ key: 'racunovodja_potrditev', label: 'Potrditev računovodje', sortable: true }
				],
				totalRows: 0,
				currentPage: 1,
				perPage: 10,
				naviLimit: 3,
				inputFilter: {
					ogrodje: null,
					libelle_modele: null,
					libelle_version: null,
					p_prodajalec_name: null,
					st_racuna: null,
					skupni_znesek: null,
					datum_racunovodja_potrdil: null
				},
				textFilterTimeout: null
			},
			zeljeneIzstavitveRacunovTable: {
				items: [],
				fields: [
					{ key: 'ogrodje', label: 'VIN' },
					{ key: 'pu_title', label: 'Prodajalec' },
					{ key: 'pk_title', label: 'Kupec' },
					{ key: 'm_zeljena_izstavitev_racuna', label: 'Datum željene izstavitve' },
					{ key: 'm_datum_izstavitve_racuna', label: 'Datum izstavitve' }
				],
				totalRows: 0,
				filter: null,
				currentPage: 1,
				perPage: 10,
				naviLimit: 3
			},
			customKontoTable: {
				items: [],
				fields: [
					{ key: 'konto_destinacije', label: 'Konto', sortable: true, class: 'dashboardCustomKontoTdKonto' },
					{ key: 'ogrodje', label: 'VIN', sortable: true, class: 'dashboardCustomKontoTdOgrodje' },
					{ key: 'libelle_modele', label: 'Model' },
					{ key: 'libelle_version', label: 'Verzija' },
					{ key: 'libelle_options', label: 'Opcije' },
					{ key: 'datum_prve_registracije', label: 'Datum prve registracije', sortable: true, class: 'dashboardCustomKontoTdDatum' },
					{ key: 'datum_kdaj_ga_moramo_prodati', label: 'Kdaj ga moramo prodati', sortable: true, class: 'dashboardCustomKontoTdDatum' },
					{ key: 'datum_kdaj_ga_lahko_prodamo', label: 'Kdaj ga lahko prodamo', sortable: true, class: 'dashboardCustomKontoTdDatum' },
					{ key: 'prodajna_cena', label: 'Prodajna cena', sortable: true },
					{ key: 'st_kilometrov', label: 'Št. kilometrov', sortable: true },
					{ key: 'status', label: 'Status' }
				],
				totalRows: 0,
				filter: '',
				inputFilter: {
					konto_destinacije: [ 'TV', 'ND', 'RV0KM' ],
					st_narocila_kupca: '',
					st_narocila_vozila: '',
					ogrodje: '',
					model: '',
					verzija: '',
					barva: '',
					staranje: '',
					stanje: null,
					status: null,
					lokacije: null,
					prodaja: null,
					prodajalec: null,
					kupec: null,
					rmadc: null,
					pmadc: null,
					omada: null,
					pdp: null,
					obljubljenaDobava: null,
					arhiv: false,
					nissan: false,
					manual: true,
					datum_prve_registracije: null,
					datum_kdaj_ga_moramo_prodati: null,
					datum_kdaj_ga_lahko_prodamo: null
				},
				currentPage: 1,
				perPage: 10,
				naviLimit: 7
			}
		}
	},
	methods: {
		potrditvePlacilTable_dataProvider: function (ctx) {
			return service.getVozilaToConfirm(ctx, this.potrditvePlacilTable_props.inputFilter)
				.then(data => {
					this.potrditvePlacilTable_props.totalRows = data.total;
					return data.items;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
					this.potrditvePlacilTable_props.totalRows = 0;
					return [];
				});
		},
		zeljeneIzstavitveRacunovTable_dataProvider: function (ctx) {
			return service.getRacuniZaIzstavit(ctx, this.user)
				.then(result => {
					this.zeljeneIzstavitveRacunovTable.totalRows = result.total;
					return result.data;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
					this.zeljeneIzstavitveRacunovTable.totalRows = 0;
					return [];
				});
		},
		customKontoTable_dataProvider: function (ctx) {
			return service.getVozilaFiltered(ctx, this.customKontoTable.inputFilter, this.user)
				.then(data => {
					this.customKontoTable.items = data;
					this.customKontoTable.totalRows = data.total;
					return this.customKontoTable.items.data;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
					this.customKontoTable.totalRows = 0;
					return [];
				});
		},
		potrditvePlacilTable_rowClick (item, index) {
			let vozilo = item.libelle_modele + ' ' + item.libelle_version;
			let kupec = this.getKupecHR(item.p_kupec, item.p_is_company, item.p_kupec_name, item.p_company);
			this.$refs.mapaModal.showModal(
				item.id,
				item.ogrodje,
				vozilo,
				item.p_prodajalec,
				item.p_prodajalec_name,
				kupec,
				0,
				item.p_datum_prodaje,
				item.p_datum_planirane_dobave,
				item.p_financiranje_rci,
				item.koncesija_datum,
				true
			);
		},
		zeljeneIzstavitveRacunovTable_rowClick (item, index) {
			let data = {
				'mapa_id': item.m_id,
				'ogrodje': item.ogrodje,
				'datum_izstavitve_racuna': item.m_datum_izstavitve_racuna
			}
			this.$refs.izstavitevRacunaModal.showModal(
				data
			);
		},
		izstavitevRacuna_success () {
			this.$refs.zeljeneIzstavitveRacunovTable.refresh();
		},
		customKontoTable_rowClick (item, index) {
			this.$refs.podrobnostiVozilaModal.showModal(
				item
			);
		},
		getKupecHR (id, isCompany, name, title) {
			if (id == null) {
				return null;
			}
			if (isCompany) {
				return title;
			}
			return name;
		},
		on_userPotrdilSuccess: function (datum, userId, userRole, akcija) {
			this.$refs.potrditvePlacilTable.refresh();
		},
		importdata_edit: function (data) {
			this.$refs.customKontoTable.refresh();
			let message = '';
			if (data.ogrodje !== '') {
				message = 'Vozilo ' + data.ogrodje + ' (#' + data.id + ') uspešno urejeno.';
			} else {
				message = 'Vozilo #' + data.id + ' uspešno urejeno.';
			}
			this.$refs.toastr.s(message);
		},
		onCustomKontoTableFilterChange: function (value) {
			this.$refs.customKontoTable.refresh();
		},
		onPotrditvePlacilTableFilterChange: function (value) {
			this.$refs.potrditvePlacilTable.refresh();
		},
		onPotrditvePlacilTableTextFilterChange: function (value) {
			if (this.potrditvePlacilTable_props.textFilterTimeout !== null) {
				clearTimeout(this.potrditvePlacilTable_props.textFilterTimeout);
			}
			this.potrditvePlacilTable_props.textFilterTimeout = setTimeout(() => {
				this.$refs.potrditvePlacilTable.refresh();
			}, settings.filterTimeoutLength);
		},
		getSoldInfo (item) {
			if (!item || !item.has_sold) {
				return '';
			}
			let hs = 'Prodajalec: ' + item.p_prodajalec_name + ';';
			let kupecHr = this.getKupecHR(item.p_kupec, item.p_is_company, item.p_kupec_name, item.p_company);
			if (kupecHr != null) {
				hs += ' Kupec: ' + kupecHr + ';';
			}
			let datumProdaje = parse(item.p_datum_prodaje, settings.dbDtFormat);
			hs += ' Datum prodaje: ' + format(datumProdaje, settings.hrsDtFormat);
			return hs;
		},
		isSold (item) {
			if (!item || !item.has_sold) {
				return false;
			}
			return true;
		},
		getTitle (value) {
			return value;
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		isRoleProdajalec () {
			return settings.isProdajalec(this.user.role);
		},
		isRoleSekretar () {
			return settings.isSekretar(this.user.role);
		},
		isRoleAdmin () {
			return settings.isAdmin(this.user.role);
		}
	}
}
</script>
<style scoped>
.cProdaja .card-body {
	padding: 0;
}
</style>
<style>
.tProdaja table thead tr {
	border-left: 1px solid #a4b7c1;
	border-right: 1px solid #a4b7c1;
}
.tProdaja .b-table {
	margin-bottom: 0;
}
.page-link.rows_total {
	text-align: center;
	margin-right: 15px;
	margin-top: 15px;
}
.navigacija {
	margin-left: 15px;
	margin-bottom: 15px;
	margin-top: 15px;
}
.dashboardCustomKontoTdKonto {
	width: 100px;
}
.dashboardCustomKontoTdOgrodje {
	width: 200px;
}
.dashboardCustomKontoTdDatum {
	width: 200px;
}
.filterRacunovodjaPotrdil {
	text-align: end;
}
</style>


// WEBPACK FOOTER //
// src/views/Aktivnosti.vue